// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA,
} from './constants';

export function confirmEditCuota(id) {
  return {
    type: SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA,
    id: id
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case SIMULADOR_FINANCIERO_CONFIRM_EDIT_CUOTA:
      if (state.editLinea) {
        let editLineaData = state.editLineaData;
        let cuotas = state.editLineaData.datosFinancieros.cuotas;
        cuotas.forEach((cuota) => {
          if (action.id === cuota.id) {
            cuota.showEdit = true;
            cuota.showDelete = true;
          }
        });
        editLineaData.datosFinancieros.cuotas = cuotas;

        return {
          ...state,
          editLineaData: editLineaData
        };
      } else {
        let altaNuevaLinea = state.altaNuevaLinea;
        let cuotas = state.altaNuevaLinea.datosFinancieros.cuotas;
        cuotas.forEach((cuota) => {
          if (action.id === cuota.id) {
            cuota.showEdit = true;
            cuota.showDelete = true;
          }
        });
        altaNuevaLinea.datosFinancieros.cuotas = cuotas;

        return {
          ...state,
          altaNuevaLinea: altaNuevaLinea
        };
      }

    default:
      return state;
  }
}
